





























































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class GroupActions extends Vue {
  @Prop() readonly groupId!: string;
}
